import Script from "next/script";
import { useEffect, useRef, useState } from "react";
import { CustomRecaptchaActions } from "utils/captcha";

type RecaptchaProps = {
  blockId?: string;
  onChange?: (validationKey: string) => void;
  onRendered?: (key: number) => void;
  action: CustomRecaptchaActions;
};

export const ReCAPTCHA = ({ action, onChange, onRendered }: RecaptchaProps) => {
  const [isApiReady, setIsApiReady] = useState(false);
  const recaptchaRef = useRef<HTMLDivElement>(null);

  const initWidgets = () => {
    window.grecaptcha?.enterprise.ready(() => {
      setIsApiReady(true);
    });
  };

  useEffect(() => {
    if (isApiReady && recaptchaRef?.current) {
      if (recaptchaRef?.current) {
        try {
          const idx = window.grecaptcha.enterprise.render(
            recaptchaRef?.current,
            {
              sitekey: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
              callback: onChange ?? (() => null),
            }
          );
          if (onRendered) {
            onRendered(idx);
          }
        } catch (e) {
          const { message } = e as { message: string };

          // this particular error is more of a warning than an error -- it failing to render it a
          // subsequent time doesn't break anything, and we can safely ignore it
          if (
            typeof message !== "string" ||
            !message.startsWith("reCAPTCHA has already been rendered")
          ) {
            throw e;
          }
        }
      }
    }
  }, [isApiReady, onChange, onRendered]);

  return (
    <>
      <Script
        src="https://www.google.com/recaptcha/enterprise.js?render=explicit"
        onLoad={initWidgets}
      />
      <div data-action={action} ref={recaptchaRef}></div>
    </>
  );
};
